// NotificationsScreen.js
import React, {useState, useContext} from "react";
import {Dimensions, RefreshControl, ScrollView, StatusBar, StyleSheet, Text, View} from "react-native";
import {getAccessToken} from "../helpers/storage";
import noNotificationAnimation from '../../assets/animations/no-notification.json';
import LottieView from "lottie-react-native";
import {useTranslation} from "react-i18next";
import { OrdersContext } from "../helpers/OrdersContext";
import { CurrentScreenContext } from "../helpers/CurrentScreenContext";
import OrderRow from "../components/OrderRow";
const {width, height} = Dimensions.get('window');

export default function NotificationsScreen({navigation}) {
    const {t} = useTranslation();
    const [localStorage, setLocalStorage] = React.useState(null);
    const [refreshing, setRefreshing] = React.useState(false);
    const {orders} = React.useContext(OrdersContext);
    const { setCurrentScreen } = useContext(CurrentScreenContext);
    const [pendingOrders, setPendingOrders] = React.useState([])

    React.useEffect(() => {
        const checkLogin = async () => {
            if (await getAccessToken()) {
                setLocalStorage(await getAccessToken())
                //navigation.navigate("HomeScreen");
            }
        }
        checkLogin();
    }, [navigation]);

    React.useEffect(() => {
        // Set current screen when component mounts
        setCurrentScreen('NotificationsScreen');

        // Reset current screen when component unmounts
        return () => {
            setCurrentScreen(null);
        };
    }, [setCurrentScreen]);

    React.useEffect(() => {console.log("1")
        const pendingOrdersArray = orders.filter(order => (order.status === "pending" && !order.storno )) || [];
        if(orders){
            setPendingOrders(pendingOrdersArray);
        }
        if(pendingOrdersArray.length === 0){
            //navigation.navigate("OnlineScreen")
        }
        }, [orders]);


    const onRefresh = async () => {
        setRefreshing(true);
        // Add your refresh logic here
        setTimeout(() => {
            setRefreshing(false);
        }, 2500)
    };


    return (
        <View
            style={styles.background}
        >
            <StatusBar backgroundColor="transparent" translucent barStyle="dark-content"/>
            <ScrollView refreshControl={
                <RefreshControl refreshing={refreshing} onRefresh={onRefresh}/>
            } style={styles.container}>
                <View style={{
                    flex: 1,
                    alignContent: 'center',
                    alignItems: 'center'
                }}>
                    {pendingOrders?.length > 0 ? (<View style={{width:'90%'}}>
                        {pendingOrders.map((order)=>
                            <OrderRow
                            key={order.orderCode}
                            order={order}
                            onPress={() => navigation.navigate('OrderDetailsScreen', { orderData: order, orderId: order._id })}
                        />)}

                    </View>) : (<View style={{
                        flex: 1,
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginBottom: 60
                    }}>
                        <LottieView
                            source={noNotificationAnimation}
                            autoPlay
                            loop={true}
                            style={styles.lottie}
                            renderMode={'AUTOMATIC'}
                            resizeMode={'center'}
                            enableSafeModeAndroid={true}
                        />
                        <Text style={{fontSize: 22, color: 'yellow', marginTop: -80}}>{t('no_notifications')}</Text>
                    </View>
                   )}
                </View>

            </ScrollView>
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        backgroundColor: '#393939',
        flex: 1,
        width: '100%',
        height: height - 90
    },
    webview: {
        flex: 1,
        width: '100%',
        height: height - 90
    },
    animationContainer: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center'
    },
    lottie: {
        width: 600,
        height: 600
    },
    background: {
        flex: 1,
        background: '#393939',
        width: '100%',
        height: height - 90
    },
});
